export default __webpack_public_path__ + "assets/dcd8fe2a775ecbc16bd672fa466f04b6.png";